// Types
import { IContactAddress } from '@trii/types/dist/Contacts';

const getEditedField = (
  key: string,
  originalValue: string | number | null,
  editedValue: string | number
): Record<string, string | number> | null => {
  if (
    originalValue !== editedValue &&
    !(originalValue === null && editedValue === '')
  ) {
    const editedField: Record<string, string | number> = {};

    editedField[key] = editedValue;
    return editedField;
  }
  return null;
};

const getAddressesWithUpdatedValues = (
  newValue: string,
  newValueAddressId: string,
  addresses: IContactAddress[]
): IContactAddress[] => {
  const newAddresses = addresses.map((address) => {
    if (address.id === newValueAddressId) {
      return {
        ...address,
        address: newValue,
      };
    }
    return address;
  });

  return newAddresses;
};

export default { getEditedField, getAddressesWithUpdatedValues };
